import { render } from "./SummaryView.vue?vue&type=template&id=5340efc9&scoped=true&ts=true"
import script from "./SummaryView.vue?vue&type=script&lang=ts"
export * from "./SummaryView.vue?vue&type=script&lang=ts"

import "./SummaryView.vue?vue&type=style&index=0&id=5340efc9&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5340efc9"]])

export default __exports__